<div class="container-fluid px-2 mt-3 ">
  <div class="row">
    <div class="col-12 flex-sm-column flex-md-row gap-2 d-flex  h-100">
      <form class="row col-12 g-3">
        <!-- Shop Name -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'shopName'" 
            [inputType]="'text'"
            [inputId]="'shopName'" 
            [inputValue]="businessDetails?.shopName"
            [inputLabel]="'Shop Name'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.shopName=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <!-- Business License No -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [onlyNumbers]="true"
            [inputName]="'businessLicenceNo'" 
            [inputType]="'text'"
            [inputId]="'businessLicenceNo'" 
            [inputValue]="businessDetails?.businessLicenceNo"
            [inputLabel]="'Business License No.'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.businessLicenceNo=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <!-- Pan Card -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'panCard'" 
            [inputType]="'text'"
            [inputId]="'panCard'" 
            [inputValue]="businessDetails?.panCard"
            [inputLabel]="'Pan Card'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.panCard=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <!-- Registration Date -->
        <div class="col-12 pe-0 col-md-6">
          <app-date-picker [customClass]="'text-black'" [labelName]="'Registration Date'"
            [fromDateFromParent]="businessDetails.registrationDate" [clearValue]="true"
            [inputDate]="businessDetails.registrationDate" (selectedDate)="businessDetails.registrationDate=$event;handleDateSelection($event)" [isRequired]="false">
          </app-date-picker>
        </div>

        <!-- Registration Country -->
        <div class="col-12 pe-0 col-md-6">
          <app-dropdown 
            [options]="dropdownnData?.countryDropdown" 
            [labelName]="'Registration Country'"
            [selectedOption]="businessDetails.registrationCountry"
            [selectedId]="businessDetails.registrationCountry"
            (dropdownValueEmit)="businessDetails.registrationCountry = $event">
          </app-dropdown>
        </div>

        <!-- Jurisdiction -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'jurisdiction'" 
            [inputType]="'text'"
            [inputId]="'jurisdiction'" 
            [inputValue]="businessDetails?.jurisdiction"
            [inputLabel]="'Jurisdiction'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.jurisdiction=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <!-- Business Email -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'businessEmail'" 
            [inputType]="'text'"
            [inputId]="'businessEmail'" 
            [inputValue]="businessDetails.businessEmail"
            [inputLabel]="'Business Email'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.businessEmail=$event"
            [isRequired]="false"
            [isPassPattern]="true"
          ></app-input>
        </div>

        <!-- GST -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'gstTrn'" 
            [inputType]="'text'"
            [inputId]="'gstTrn'" 
            [inputValue]="businessDetails.gstTrn"
            [inputLabel]="'GST'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.gstTrn=$event"
            [isRequired]="false"
          ></app-input>
        </div>
        <div class="d-flex gap-3" *ngIf="data?.navigateFrom == NavigateToCustomerDetails.MinizUserRegistration">
          <div class="col pe-0">
            <app-input appOnlyNumbers [inputName]="'amount'" [inputType]="'text'" [inputId]="'amount'"
              [inputValue]="businessDetails?.amount" [inputLabel]="'Amount'" (inputValueEmit)="onAmountChange($event)"
              [isRequired]="false">
            </app-input>
          </div>
          <div class="col-3 pe-0">
            <app-input appOnlyNumbers [allowDecimal]="true" [decimalPlaces]="2" [inputName]="'taxInPercent'"
              [inputType]="'text'" [inputId]="'taxInPercent'" [inputValue]="businessDetails?.taxInPercent"
              [inputLabel]="'Tax % (In Percent)'" (inputValueEmit)="onTaxInPercentChange($event)" [isRequired]="false">
            </app-input>
          </div>
          <div class="col pe-0">
            <app-input [disabled]="true" [allowDecimal]="true" [decimalPlaces]="2" appOnlyNumbers [inputName]="'totalAmount'"
              [inputType]="'text'" [inputId]="'totalAmount'" [inputValue]="businessDetails?.totalAmount"
              [inputLabel]="'Total Amount'" (inputValueEmit)="onTotalAmountChange($event)" [isRequired]="false">
            </app-input>
          </div>
        </div>
        <!-- Slogan -->
        <div class="col-12 pe-0 col-md-6">
          <app-input 
            [inputName]="'slogan'" 
            [inputType]="'text'"
            [inputId]="'slogan'" 
            [inputValue]="businessDetails.slogan"
            [inputLabel]="'Slogan'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.slogan=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <!-- Installed By -->
        <div class="col-12 pe-0 col-md-6" *ngIf="data?.navigateFrom!==NavigateToCustomerDetails.MinizUserRegistration">
          <app-input 
            [inputName]="'installedBy'" 
            [inputType]="'text'"
            [inputId]="'installedBy'" 
            [inputValue]="businessDetails.installedBy"
            [inputLabel]="'Installed By'"
            [inputPlaceholder]="''"
            (inputValueEmit)="businessDetails.installedBy=$event"
            [isRequired]="false"
          ></app-input>
        </div>

        <div *ngIf="data?.navigateFrom==NavigateToCustomerDetails.MinizUserRegistration" class="d-flex justify-content-between gap-2 col-12 col-md-6">
          <div class="col-12 pe-0">
            <app-dropdown [options]="dropdownnData?.installFromDropdown" [labelName]="'Installed From'"
              [selectedOption]="businessDetails.installedFrom" [selectedId]="businessDetails.installedFrom"
              (dropdownValueEmit)="businessDetails.installedFrom = $event" [inputId]="'installedFrom'">
            </app-dropdown>
          </div>
        
          <!-- temporary d-none (for future use) Miniz User Registration -->
          <div class="col-5 pe-0 d-none">
            <app-input [inputName]="'installedBy'" [inputType]="'text'" [inputId]="'installedBy'"
              [inputValue]="businessDetails.installedBy" [inputLabel]="'Installed By'" [inputPlaceholder]="'Installed By'"
              (inputValueEmit)="businessDetails.installedBy=$event" [isRequired]="false"></app-input>
          </div>
        </div>

        <!-- Comment -->
        <div class="col-12 pe-0 textarea-div d-flex flex-column">
          <label for="comment" class="m-0 p-0">Comment</label>
          <textarea class="w-100 form-control" [(ngModel)]="businessDetails.comment" name="comment" id="comment"></textarea>
        </div>

      </form>

    </div>
  </div>
</div>
